import { graphql } from 'src/graphql';

import { ShareFieldsFragment } from 'src/modals/ManageSharingModal/queries/ShareFields.fragment';

export const ShareByEmails = graphql(
  `
    mutation ShareByEmails($emails: [String!]!, $input: ShareTypeInput!) {
      shareByEmails(emails: $emails, input: $input) {
        ...ShareFieldsFragment
      }
    }
  `,
  [ShareFieldsFragment],
);

export const CurrentShares = graphql(
  `
    query CurrentShares($first: Int!, $filter: SharesFilter) {
      shares(first: $first, filter: $filter) {
        nodes {
          ...ShareFieldsFragment
        }
      }
    }
  `,
  [ShareFieldsFragment],
);
